import angular from 'angular';

angular.module('neurotecAbisWebClientApp')
	.directive('stickyHeaderAdmin', () => ({
		template: require('../../../views/directives/admin/sticky-header-admin.html'),
		restrict: 'E',
		replace: true
	}));
